import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';

import { getErrorMessage } from '~libs/axiosWrapper';

import { ErrorResponse, ModalCard, Spinner } from '~components';
import { InputProps } from '~components/form-fields';

import { SahAssignment, useBulkSahAssignMutation } from '~support-at-home/actions/budgets';

interface AssignValue {
  budget_ids: string[];
  assignments: SahAssignment[];
}

interface ComponentProps extends InputProps {
  value: AssignValue;
}

const AssignResults: React.FC<ComponentProps> = ({ value }) => {
  const { assignments = [], budget_ids = [] } = value;

  const [bulkSahAssign, { isLoading, error, data }] = useBulkSahAssignMutation();

  useEffect(() => {
    if (assignments.length) {
      bulkSahAssign({ assignments });
    }
    // Mount-only: assignments are finalised before this wizard step renders and cannot
    // change while it is displayed. Re-running on every render would duplicate the API call.
  }, []);

  if (isLoading) return <Spinner loading />;

  if (error) return <ErrorResponse message={getErrorMessage(error)} />;

  if (!data) {
    if (assignments.length === 0) {
      return (
        <Alert color="info" className="m-3">
          No assignments to process.
        </Alert>
      );
    }
    return null;
  }

  const { assigned_count } = data;
  const skippedCount = Math.max(0, budget_ids.length - assignments.length);

  return (
    <ModalCard header="Assignment Results" className="w-100" isOpen allowOpen={false}>
      <div className="p-2">
        <p className="mb-1">
          <strong>{assigned_count}</strong> SAH budget{assigned_count !== 1 ? 's' : ''} assigned successfully.
        </p>
        {skippedCount > 0 && (
          <p className="text-muted mb-0">
            <strong>{skippedCount}</strong> budget{skippedCount !== 1 ? 's' : ''} skipped (no match or not selected).
          </p>
        )}
      </div>
    </ModalCard>
  );
};

export default AssignResults;
